import { PersistPartial } from 'redux-persist/es/persistReducer';
import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer, Persistor } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "store/reducers";
import { RootState } from 'store/types';
import { removePreviousVersionsStorage } from 'utils/storage';

const VERSION: string = process.env.REACT_APP_VERSION as string;
const PREFIX: string = 'root';

const persistConfig = {
  key: `${PREFIX}:${VERSION}`,
  storage,
};

removePreviousVersionsStorage(PREFIX, VERSION);

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);
const configureStore = (initialState?: RootState & PersistPartial) => {
  let composeEnhancers = composeWithDevTools({});

  return createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  );
};

const store = configureStore();

export default store;
export type AppDispatch = typeof store.dispatch;
export const persistor: Persistor = persistStore(store);
